import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('packageFieldName', packageFieldName);

function packageFieldName(splitService) {
  return function packageFieldNameFilter(id) {
    const siteCustomPackageFields = splitService.getCustomPackageFields() || [];
    const field = siteCustomPackageFields.find((c) => {
      return c.id === id;
    });
    return field?.name || '';
  }
}
